// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fd8b2d55","453":"63834957","667":"ac73fdae"}[chunkId] + ".chunk.js";
};